// Import Static UI
import ProfileFrame from './ProfileFrame';
import DescriptionCard from './DescriptionCard';
import { IAuctionBiderObj, IItemDetail } from 'api/types/marketplace';
import BuyForm from './BuyForm';
import AuctionLeaderboard from './AuctionLeaderboard';
import BidForm from './BidForm';
import RecallForm from './RecallForm';
import RankedBidForm from './RankedBidForm';

interface Props {
  itemDetailObj: IItemDetail;
  auctionList: Array<IAuctionBiderObj>;
  itemRequestHandler: () => void;
  itemRequestLoader: boolean;
  approveTokenLoader: boolean;
  isTokenApproved: boolean;
  itemRecallRequestHandler: () => void;
  itemRecallRequestLoader: boolean;
  setAmount: (val: string) => void;
  approveTokenHandler: () => void;
  amount: string;
  setQuantity: (val: string) => void;
  quantity: string;
  quantityChangeHandler: (value: string, maxQuantity: number) => void;
  quantityBidValue: string;
}

const CardDetails = ({
  itemDetailObj,
  auctionList,
  itemRequestHandler,
  itemRequestLoader,
  setAmount,
  amount,
  itemRecallRequestHandler,
  itemRecallRequestLoader,
  approveTokenHandler,
  isTokenApproved,
  approveTokenLoader,
  setQuantity,
  quantity,
  quantityChangeHandler,
  quantityBidValue,
}: Props) => {
  return (
    <>
      <section className="section-card">
        <div className="section-card-wrap">
          <div className="card-lists">
            <div className="card-col-left">
              <ProfileFrame itemDetailObj={itemDetailObj} />
              <DescriptionCard itemDetailObj={itemDetailObj} />
            </div>

            <div className="card-col-right">
              {(itemDetailObj.sellType === 'buy' || itemDetailObj.sellType === 'raffle') && (
                <BuyForm
                  itemDetailObj={itemDetailObj}
                  itemRequestHandler={itemRequestHandler}
                  itemRequestLoader={itemRequestLoader}
                  approveTokenLoader={approveTokenLoader}
                  isTokenApproved={isTokenApproved}
                  approveTokenHandler={approveTokenHandler}
                  setQuantity={setQuantity}
                  quantity={quantity}
                />
              )}

              {itemDetailObj.sellType === 'bid' && itemDetailObj.isActive ? (
                <BidForm
                  itemDetailObj={itemDetailObj}
                  itemRequestHandler={itemRequestHandler}
                  itemRequestLoader={itemRequestLoader}
                  setAmount={setAmount}
                  amount={amount}
                  approveTokenLoader={approveTokenLoader}
                  isTokenApproved={isTokenApproved}
                  approveTokenHandler={approveTokenHandler}
                />
              ) : null}

              {itemDetailObj.sellType === 'ranked_bid' ? (
                <RankedBidForm
                  itemDetailObj={itemDetailObj}
                  itemRequestHandler={itemRequestHandler}
                  itemRequestLoader={itemRequestLoader}
                  approveTokenLoader={approveTokenLoader}
                  isTokenApproved={isTokenApproved}
                  approveTokenHandler={approveTokenHandler}
                  quantityChangeHandler={quantityChangeHandler}
                  quantityBidValue={quantityBidValue}
                  setAmount={setAmount}
                  amount={amount}
                  itemRecallRequestHandler={itemRecallRequestHandler}
                  itemRecallRequestLoader={itemRecallRequestLoader}
                />
              ) : null}

              {itemDetailObj.sellType === 'bid' && !itemDetailObj.isActive ? (
                <RecallForm
                  itemDetailObj={itemDetailObj}
                  itemRecallRequestHandler={itemRecallRequestHandler}
                  itemRecallRequestLoader={itemRecallRequestLoader}
                  approveTokenLoader={approveTokenLoader}
                  isTokenApproved={isTokenApproved}
                  approveTokenHandler={approveTokenHandler}
                />
              ) : null}

              {(itemDetailObj.sellType === 'bid' || itemDetailObj.sellType === 'ranked_bid') &&
                auctionList.length > 0 && (
                  <AuctionLeaderboard auctionList={auctionList} quantity={itemDetailObj.quantity} />
                )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CardDetails;
